export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_garden-grub-healing/artifacts/592hljpk_21fd3618-4a64-4167-8465-22490a1972a3-thumbnail.webp";

export const GIVING_URL = "https://checkout.square.site/merchant/MLTAD94RWDAHH/checkout/WOABSWZSQJGKHN4AFYUEEDH2?src=webqr";

export const GARDEN_REAL = "/images/garden-space.jpg";

export const REAL_PHOTOS = {
  founders: "/images/founders.jpg",
  meg: "/images/meg-harkins.jpg",
  sandra: "/images/sandra-blum.jpg",
  merger: "/images/merger-infographic.jpg",
  buildBeds: "/images/build-beds.jpg",
  meal: "/images/community-meal.jpg",
  circle: "/images/women-circle.jpg",
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Mission & Vision", path: "/mission-vision" },
  { name: "Three-Year Program", path: "/program" },
  { name: "Services & Events", path: "/services-events" },
  { name: "Get Involved", path: "/get-involved" },
  { name: "Referrals", path: "/referrals" },
  { name: "Resources", path: "/resources" },
  { name: "Contact", path: "/contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1781785273371-a959f34bfab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjb21tdW5pdHklMjBnYXJkZW4lMjBvcmdhbmljJTIwcHJvZHVjZSUyMHdvbWVuJTIwZ2FyZGVuaW5nfGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
  gardener: "https://images.unsplash.com/photo-1781785186628-e1a04569776d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjb21tdW5pdHklMjBnYXJkZW4lMjBvcmdhbmljJTIwcHJvZHVjZSUyMHdvbWVuJTIwZ2FyZGVuaW5nfGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
  harvest: "https://images.unsplash.com/photo-1624668430039-0175a0fbf006?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMG9yZ2FuaWMlMjB2ZWdldGFibGVzJTIwZ2FyZGVuJTIwaGFydmVzdCUyMGhhcnZlc3QlMjBmb29kfGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
  lavender: "https://images.unsplash.com/photo-1783890917279-91000c75e932?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxsYXZlbmRlciUyMHB1cnBsZSUyMGZpZWxkJTIwYmVlJTIwZmxvd2VyJTIwZ2FyZGVufGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
  sign: "https://images.unsplash.com/photo-1628243989859-db92e2de1340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjBnYXJkZW4lMjBvcmdhbmljJTIwcHJvZHVjZSUyMHdvbWVuJTIwZ2FyZGVuaW5nfGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
  peppers: "https://images.unsplash.com/photo-1722810767142-6052d3c10d8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMG9yZ2FuaWMlMjB2ZWdldGFibGVzJTIwZ2FyZGVuJTIwaGFydmVzdCUyMGhhcnZlc3QlMjBmb29kfGVufDB8fHx8MTc5MDkwMzY1NXww&ixlib=rb-4.1.0&q=85",
};

export const PILLARS = [
  {
    title: "Faith-Based Empowerment",
    text: "Scripture-rooted encouragement, prayer, and spiritual mentoring that rebuild identity, dignity, and hope.",
  },
  {
    title: "Holistic Health Coaching",
    text: "One-on-one coaching for mind, body, and spirit — building rhythms of rest, movement, and emotional wellness.",
  },
  {
    title: "Nourishment Through Food",
    text: "Cooking education, shared meals, and nutrition skills that turn the table into a place of healing.",
  },
  {
    title: "Gardening for Sustainability",
    text: "Hands in the soil. Women grow fresh produce, learn food security, and watch new life take root — in the garden and in themselves.",
  },
  {
    title: "Community Engagement",
    text: "A sisterhood of support circles, service projects, and celebration — because no one heals alone.",
  },
  {
    title: "Professional Collaboration",
    text: "We walk alongside licensed mental health and community professionals so every woman is surrounded by coordinated care.",
  },
];

export const YEARS = [
  {
    num: "Year 1",
    name: "Foundation of Healing & Empowerment",
    color: "wing",
    text: "Safety, stability, and spiritual grounding. Women begin with trauma-informed support, faith-based empowerment, health coaching, and nourishing food — rebuilding trust in themselves and community.",
    points: ["Safe, welcoming community", "Faith & prayer foundation", "Holistic health coaching", "Nutrition & shared meals"],
  },
  {
    num: "Year 2",
    name: "Personal Growth & Community Engagement",
    color: "garden",
    text: "Roots deepen. Women step into gardening for sustainability, vocational skill-building, and active service — discovering their gifts by giving them away.",
    points: ["Gardening & food sustainability", "Vocational training begins", "Serving the community", "Leadership skills emerge"],
  },
  {
    num: "Year 3",
    name: "Transition to Self-Sufficiency & Leadership",
    color: "pollen",
    text: "Wings open. Women move toward employment, housing stability, and financial confidence — and many return as mentors and leaders for the next class.",
    points: ["Employment & career readiness", "Financial independence", "Housing stability support", "Mentoring the next class"],
  },
];
